import { Endpoint } from '@business/api/endpoint';
import { TMEstimatorTemplateFeeId, TMEstimatorTemplateFeeResponse } from '@business/entities/tm/TMEstimatorTemplateFeeResponse';
import { TMEstimatorTemplateFeeFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditEstimatorTemplateFeeModal/AddEditEstimatorTemplateFeeModal';

export function fetchTMEstimatorTemplateFees() {
  return Endpoint.get<TMEstimatorTemplateFeeResponse[]>(`@gc/estimator-template-fees`);
}

export function createTMEstimatorTemplateFee(data: TMEstimatorTemplateFeeFormData) {
  return Endpoint.post<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees`, { data });
}

export function updateTMEstimatorTemplateFee(estimatorTemplateFeeId: TMEstimatorTemplateFeeId, data: TMEstimatorTemplateFeeFormData) {
  return Endpoint.patch<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`, { data });
}

export function deleteTMEstimatorTemplateFee(estimatorTemplateFeeId: TMEstimatorTemplateFeeId) {
  return Endpoint.delete<void>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`);
}

export function fetchTMEstimatorTemplateFee(estimatorTemplateFeeId: TMEstimatorTemplateFeeId) {
  return Endpoint.get<TMEstimatorTemplateFeeResponse>(`@gc/estimator-template-fees/${estimatorTemplateFeeId}`);
}

export function getFeeVariables() {
  return Endpoint.get<string[]>(`@gc/estimator-template-fees/variables`);
}
